import { render, staticRenderFns } from "./OrderCopy.vue?vue&type=template&id=3c818e53&scoped=true"
import script from "./OrderCopy.vue?vue&type=script&lang=js"
export * from "./OrderCopy.vue?vue&type=script&lang=js"
import style0 from "./OrderCopy.vue?vue&type=style&index=0&id=3c818e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c818e53",
  null
  
)

export default component.exports